"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _CustomLegend = require("../../shared/recharts/CustomLegend");
var _CustomTooltip = _interopRequireDefault(require("../../shared/recharts/CustomTooltip"));
var _formatGraphPrice = require("../../utils/formatGraphPrice");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BarAndLineComposedChart = ({
  data = [],
  bars,
  lines,
  xAxisDataKey,
  yAxisDataKey,
  height = '350px',
  width = '100%',
  xAxisLine = false,
  yAxisLine = false,
  tickLineY = false,
  tickLineX = false,
  margin,
  legendHAlign = 'left',
  legendVAlign = 'bottom',
  legendPadding,
  layout = 'horizontal',
  lineStrokeWidth = 1,
  hasYAxis = true,
  cartesianGrid = true,
  legend = true,
  stack = true,
  referenceLine = true,
  maxBarSize,
  barGap,
  barRadius,
  ...rest
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BarAndLineComposedChartContainer, {
    width: width && width,
    height: height && height,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.ComposedChart, {
        data: data && data,
        margin: {
          top: 0.5,
          right: 50,
          bottom: 0,
          left: 0,
          ...margin
        },
        layout: layout && layout,
        stackOffset: "sign",
        barGap: barGap,
        ...rest,
        children: [referenceLine && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ReferenceLine, {
          y: 0,
          stroke: "white"
        }), cartesianGrid && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
          horizontal: true,
          vertical: false
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, {
          dataKey: xAxisDataKey && xAxisDataKey,
          axisLine: xAxisLine && xAxisLine,
          tickLine: tickLineX && tickLineX,
          type: layout === 'vertical' ? 'number' : 'category',
          tickMargin: 5,
          tickFormatter: _formatGraphPrice.formatAxisPrice
        }), hasYAxis && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, {
          dataKey: yAxisDataKey && yAxisDataKey,
          axisLine: yAxisLine && yAxisLine,
          tickLine: tickLineY && tickLineY,
          type: layout === 'vertical' ? 'category' : 'number',
          tickFormatter: _formatGraphPrice.formatAxisPrice
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomTooltip.default, {
            barConfig: bars && bars,
            lineConfig: lines && lines
          })
        }), legend && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Legend, {
          verticalAlign: legendVAlign && legendVAlign,
          align: legendHAlign && legendHAlign,
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomLegend.CustomLegend, {}),
          wrapperStyle: {
            paddingLeft: legendPadding?.left ? legendPadding.left : '5px',
            paddingTop: legendPadding?.top ? legendPadding.top : '10px',
            paddingBottom: legendPadding?.bottom ? legendPadding.bottom : '0',
            paddingRight: legendPadding?.right ? legendPadding.right : '0'
          }
        }), bars?.length && bars.map(bar => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Bar, {
            dataKey: bar.dataKey,
            fill: bar.fill,
            name: bar.name,
            maxBarSize: maxBarSize || undefined,
            stackId: stack ? 'stack' : undefined,
            radius: barRadius
          }, bar.name);
        }), lines?.length && lines.map(line => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Line, {
            type: line.type,
            dataKey: line.dataKey,
            stroke: line.stroke,
            name: line.name,
            strokeWidth: lineStrokeWidth
          }, line.name);
        })]
      })
    })
  });
};
var _default = exports.default = BarAndLineComposedChart;